<app-header></app-header>
<app-home></app-home>
<app-work></app-work>
<app-skills></app-skills>
<app-contact></app-contact>
<app-footer></app-footer>